import { render, staticRenderFns } from "./block-organization-sign-preview.vue?vue&type=template&id=478f4a75&scoped=true&lang=pug"
import script from "./block-organization-sign-preview.vue?vue&type=script&lang=js"
export * from "./block-organization-sign-preview.vue?vue&type=script&lang=js"
import style0 from "./block-organization-sign-preview.vue?vue&type=style&index=0&id=478f4a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f4a75",
  null
  
)

export default component.exports